module.exports = __webpack_public_path__ + "media/images/flags/32/Turkmenistan-85a6e1c1eca5ad8500fd42a2c1f85c58.png";